// builder-components.ts
import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

const FooterCallComponent = dynamic(() => import('./footer-call-component'));

Builder.registerComponent(FooterCallComponent, {
  name: 'FooterCallComponent',
  noWrap: true,
});
